module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qback1-fae1f14d39fc5b4337a1fa0649e59a87.jpg";